import React from "react";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";

/**
 * Small inline banner for the contract-details screen. Two uses on web:
 *  - Flow C subcontract auth-hold: a message + a "Pay Now" action button (G2).
 *  - WAITING/BLOCKED status explanation: message only, no action (G12).
 * `messageId` and `actionTextId` are i18n ids rendered via <FormattedMessage>.
 * When `onAction` is omitted the banner is informational (no button).
 */
const ContractStatusBanner = ({
  messageId,
  actionTextId,
  onAction,
  loading = false,
  testId = "contract-details-status-banner",
}) => {
  if (!messageId) {
    return null;
  }
  return (
    <div
      data-testid={testId}
      className="mt-4 mb-3 p-3"
      style={{
        border: "1px solid #f77e0b",
        borderRadius: "8px",
        backgroundColor: "#fff7ef",
      }}
    >
      <div className="fw-bold mb-2" style={{ color: "#5e5e5e" }}>
        <FormattedMessage id={messageId} />
      </div>
      {onAction && (
        <Button
          className="w-100 fw-bold"
          style={{
            backgroundColor: "#f77e0b",
            height: "48px",
            color: "white",
          }}
          loading={loading}
          onClick={onAction}
        >
          <FormattedMessage id={actionTextId || "PAY_NOW"} />
        </Button>
      )}
    </div>
  );
};

export default ContractStatusBanner;
